import Image from 'global/Image';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import { useSelector } from 'react-redux';
import { selectors } from 'lib/entities/profile';
import {
  FieldsetWrapper,
  ItemContainer,
  Modal,
  Next,
} from 'features/community/styled';
import { useShareReceipt } from 'features/community/hooks/useShareReceipt';

interface Props {
  onOk: () => void;
  leaderName?: string;
  name: string;
  visible: boolean;
}

function Done({ onOk, leaderName, name, visible }: Props) {
  const {
    data: { phone, username },
  } = useSelector(selectors);
  const showModal = useShareReceipt((store) => store.showShareModal);

  const handleShareClick = () => {
    showModal(leaderName, name, username, phone);
  };

  return (
    <Modal
      visible={visible}
      closeIcon={
        <Image
          src="/icon/close.svg"
          width="10px"
          height="10px"
          style={{ display: 'none' }}
        />
      }
      width={500}
      title={
        // @ts-expect-error
        <ItemContainer align="center" justify="center" mb="40px">
          <Text size="18px" height="24.3px" family="bold" align="center">
            Aktivasi Kode
          </Text>
          <Text size="18px" height="24.3px" family="bold" align="center">
            Komunitas Berhasil
          </Text>
        </ItemContainer>
      }
      footer={[
        // @ts-expect-error
        <Flex align="center" justify="center" mt="20px">
          <Button
            width="100%"
            onClick={handleShareClick}
            type="outline-primary"
            // @ts-expect-error
            p="12px"
            mr="8px"
            radius="4px"
          >
            <Text family="bold" color="#00ab6b" size="14px" height="19px">
              Bagikan Bukti
            </Text>
          </Button>
          <Next width="100%" onClick={onOk} type="outline-primary">
            <Text family="bold" color="white" size="14px" height="19px">
              Selesai
            </Text>
          </Next>
        </Flex>,
      ]}
    >
      <ItemContainer align="center" justify="center">
        <Image
          alt="logo"
          src="images/community/hero.svg"
          width={180}
          height={140}
        />
        {/* @ts-expect-error */}
        <ItemContainer align="center" justify="center" my="20px">
          <Text size="14px" height="21px" align="center">
            Berhasil bergabung dalam komunitas
          </Text>
          <Text size="14px" height="21px" family="bold" align="center">
            {name}
          </Text>
        </ItemContainer>
      </ItemContainer>
      <FieldsetWrapper>
        {/* @ts-expect-error */}
        <Flex justify="space-between" align="flex-start" mb="12px">
          <span>Stockbit Username</span>
          <strong>{username}</strong>
        </Flex>
        <Flex justify="space-between" align="flex-start">
          <span>No. HP</span>
          <strong>{phone}</strong>
        </Flex>
      </FieldsetWrapper>
    </Modal>
  );
}

export default Done;
